/** @jsxImportSource @emotion/react */
import type { css } from '@emotion/react'

import type { LinksLinkListComponent } from '@twisto/api-cms'

import { BaseLink, LinkBlock } from 'homepage/components/atoms'

import * as styles from './link-list.styles'

type LinkListProps = {
  listStyles?: ReturnType<typeof css>
  isBold?: boolean
  hasUnderline?: boolean
}

export const LinkList = ({
  blocks,
  links,
  listStyles,
  name,
  isBold = false,
  hasUnderline = false,
}: LinksLinkListComponent & LinkListProps) => (
  <ul css={[styles.list, listStyles]}>
    {name && <li css={styles.name}>{name}</li>}
    {links?.map((link) => (
      <li
        key={link.id}
        css={(theme) => [
          styles.item(theme, hasUnderline),
          link.indent && styles.indent,
          isBold && styles.bold,
        ]}
      >
        <BaseLink {...link} />
      </li>
    ))}
    {blocks?.map((block) => (
      <li key={block.id} css={(theme) => styles.item(theme)}>
        <LinkBlock {...block} />
      </li>
    ))}
  </ul>
)
